import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    retrieved: {
      contacts: [],
    },
    position: {
      lat: 0,
      lng: 0
    },
    contacts: [],
    addresses: [],
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/company/show/index.js